<script>
export default {
  name: "VueHeader",
  props: ["currentTab", "tabs"],
  emits: ["setTab"],

  methods: {
    setTab(idx) {
      this.$emit("setTab", idx);
    },
  },
}
</script>

<template>
  <div class="header">
    <div class="header-left">
      <span style="display: block; margin: auto; color: #fdfdfd">Gian Rinaldo Carli</span>
    </div>
    <div class="header-center">
      <RouterLink class="header-link" :key="idx" v-for="(tab, idx) in tabs" :to="`/${tab.link}`">
        {{ tab.name }}
      </RouterLink>
    </div>

    <div class="header-right">
      <router-link class="header-link" style="display: block; margin: auto; color: #fdfdfd" to="/vita">San Francesco</router-link>
    </div>
  </div>
</template>

<style>
.header {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  background: #181a1c;
  height: 48px;
  position: sticky;
  width: calc(100% - 20px);
  margin: 10px auto;
  box-sizing: border-box;
  border-radius: 40px;
  overflow: hidden;
  padding: 5px 20px;
  box-shadow: 0px 0px 0px 1.5px rgb(39, 41, 43);
  justify-content: space-between;
  place-items: center;
  align-content: center;
  max-width: 1200px;
}


.header-left {
  display: flex;
  justify-content: left;
  align-content: center;
  background: #181a1c;
  padding: 0px 5px 0px 5px;
}

.header-center {
  display: flex;
  justify-content: center;
  align-content: center;
  background: #181a1c;
  padding: 0px 0px 0px 40px;
  margin: auto;
}

.header-right {
  display: flex;
  justify-content: right;
  background: #181a1c;
  padding: 0px 5px 0px 60px;
}

.header-link {
  padding: 0 5px;
  text-decoration: none;
  color: inherit;
}

.header-link:hover {
  color: #fdfdfd;
  text-decoration: none;
  cursor: pointer;
}


.header-link.router-link-active{
  color: #fdfdfd;
}
</style>